<template>
  <div>
    <form :id='formID'>
      <div class='h-dialogContainer'>
        <div class='row h-row-inputBox' >
          <div class='col-sm-12 h-col-inputBox'>
            <div v-for='(filterType, index) in filterTypeList' :key='index' class='col-sm-3 nopadding'>
              <ejs-radiobutton ref='filterType' name='filterType' :label='filterType.label' :value='filterType.value' :checked='filterType.checked' :change='radioChange'></ejs-radiobutton>
            </div>
          </div>
          <div v-show='!isImport && isShowAll' class='col-sm-12 h-col-inputBox'>
            <div class='h-inputLit'>{{$ts('Track.filterConditions')}}:</div>
            <ejs-dropdownlist name='condition' ref='condition' :fields='condition.fields' :dataSource='condition.data'
                              popupHeight='auto' :placeholder='condition.waterMark' v-model='params.condition' :value='condition.value' :text='condition.text'></ejs-dropdownlist>
          </div>
          <div v-show='isShowAll' class='col-sm-12 h-col-inputBox'>
            <div class='h-inputLit'>{{$ts('Track.attributeName')}}:</div>
            <ejs-dropdownlist name='attributeName' ref='attributeName' :fields='attributeName.fields' :dataSource='attributeName.data'
                              popupHeight='auto' :placeholder='attributeName.waterMark' v-model='params.attributeName' :change='nameChange' :text='attributeName.text'></ejs-dropdownlist>
          </div>
          <div v-show='isShowAll' class='col-sm-12 h-col-inputBox'>
            <div class='h-inputLit'>{{$ts('Track.expression')}}:</div>
            <ejs-dropdownlist name='cron' ref='cron' :fields='cron.fields' :dataSource='cron.data' popupHeight='auto'
                              :placeholder='cron.waterMark' v-model='params.cron'  :query="cron.query" :text='cron.text' ></ejs-dropdownlist>
          </div>
          <div v-show='valueType == 1 && isShowAll' class='col-sm-12 h-col-inputBox'>
            <div class='h-inputLit'>{{$ts('Track.attributeValues')}}:</div>
            <ejs-textbox name='attributeValue1' v-model='params.attributeValue1'></ejs-textbox>
          </div>
          <div v-show='valueType == 2 && isShowAll' class='col-sm-12 h-col-inputBox'>
            <div class='h-inputLit'>{{$ts('Track.attributeValues')}}:</div>
            <ejs-dropdownlist name='attributeValue2' :fields='attributeValue.fields' :dataSource='attributeValue.data'
                              popupHeight='auto' :placeholder='attributeValue.waterMark' v-model='params.attributeValue2' :text='attributeValue.text'></ejs-dropdownlist>
          </div>
          <div v-show='valueType == 3 && isShowAll' class='col-sm-12 h-col-inputBox'>
            <div class='h-inputLit'>{{$ts('Track.attributeValues')}}:</div>
            <ejs-datetimepicker name='attributeValue3' :placeholder='attributeValue.waterMark' :allowEdit='true' :locale='locale'
                                :format='dataFormat' step='1' timeFormat='HH:mm:ss' v-model='params.attributeValue3'></ejs-datetimepicker>
          </div>
        </div>
        <div class='h-clear-rowMg'></div>
      </div>
    </form>
  </div>
</template>
<script>
  import { FormValidator } from '@syncfusion/ej2-vue-inputs';
  import { Query } from '@syncfusion/ej2-data';
  import i18n from '../../../../plugins/i18n.js';

  export default {
    name: 'FilterForm',
    props: {
      isImport: { type: Boolean, default: false },
      param: { type: String, default: '' },
      formId: { type: String, default: '' }
    },
    data() {
      return {
        formID: `filter${this.guid()}`,
        filterTypeList: [
          { label: this.$ts('Track.filter'), value: '1', checked: false },
          { label: this.$ts('Track.all'), value: '2', checked: true }
        ],
        dataFormat: 'yyyy-MM-dd HH:mm:dd',
        primaryDatas: [],
        valueType: 1,
        isShowAll: false ,
        locale: localStorage.getItem('locale'),
        filterTypeCheckValue: '2',
        height: '220px',
        condition: {
          waterMark: this.$ts('Track.pleaseSelect'),
          enableFlag: false,
          text: '',
          fields: {
            text: 'Text',
            value: 'Value',
            isChecked: 'Selected'
          },
          data: [
            { Text: this.$ts('Track.historyFilter'), Value: '0' },
            { Text: this.$ts('Track.realTimeFiltering'), Value: '1' }
          ]
        },
        attributeName: {
          waterMark: this.$ts('Track.pleaseSelect'),
          enableFlag: false,
          text: '',
          fields: {
            text: 'Text',
            value: 'Value',
            isChecked: 'Selected'
          },
          data: [
            { Text: '信令ID', Value: 'taskId' },
            { Text: '任务名称', Value: 'taskName', Selected: true }
          ]
        },
        cron: {
          waterMark: this.$ts('Track.pleaseSelect'),
          enableFlag: false,
          text: '',
          query: null,
          fields: {
            text: 'Text',
            value: 'Value',
            isChecked: 'Selected'
          },
          data: [
            { Text: '=', Value: 'equal', nameID: 'taskId,taskName' },
            { Text: '>', Value: 'greaterthan', nameID: 'taskId', Selected: true },
            { Text: '<', Value: 'lessthan', nameID: 'taskId' },
            { Text: '>=', Value: 'greaterthanorequal', nameID: 'taskId' },
            { Text: '<=', Value: 'lessthanorequal', nameID: 'taskId' },
            { Text: '!=', Value: 'notequal', nameID: 'taskId,taskName' },
            { Text: '包含', Value: 'contains', nameID: 'taskName' },
          ]
        },
        attributeValue: {
          waterMark: this.$ts('Track.pleaseSelect'),
          enableFlag: false,
          text: '',
          fields: {
            text: 'Text',
            value: 'Value',
            isChecked: 'Selected'
          },
          data: [
            { Text: '信令ID', Value: 'taskId' },
            { Text: '任务名称', Value: 'taskName', Selected: true }
          ]
        },
        SearchHolder: {
          type: String,
          default() {
            return '';
          },
        },
        params: {
          filterType: '2',
          condition: '',
          attributeName: '',
          cron: '',
          attributeValue1: '',
          attributeValue2: '',
          attributeValue3: ''
        },
        validationOption: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          }
        }
      };
    },
    methods: {
      $ts(args) {
        const mes = args.split('.');
        const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
        return result;
      },
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxx'.replace(/[xy]/g, c => {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : ((r & 0x3) | 0x8);
          return v.toString(16);
        });
      },
      radioChange(args) {
        this.filterTypeCheckValue = args.value;
        const flag = args.value === '1';
        this.params.filterType = args.value;
        this.isShowAll = flag;
        // this.condition.enableFlag = flag;
        // this.attributeName.enableFlag = flag;
        // this.cron.enableFlag = flag;
        // this.attributeValue.enableFlag = flag;
        if (args.value === '1') {
          if (!this.isImport) {
            this.formObj.addRules('condition', {
              required: [true, `${this.$ts('Track.fieldIsRequired')}`]
            });
          }
          this.formObj.addRules('attributeName', {
            required: [true, `${this.$ts('Track.fieldIsRequired')}`]
          });
          this.formObj.addRules('cron', {
            required: [true, `${this.$ts('Track.fieldIsRequired')}`]
          });
        } else {
          if (!this.isImport) {
            this.formObj.removeRules('condition');
          }
          this.formObj.removeRules('attributeName');
          this.formObj.removeRules('cron');
          const errorDom = document.querySelectorAll('label.e-error');
          for (let i = 0; i < errorDom.length; i++) {
            errorDom[i].innerHTML = '';
          }
        }
      },
      nameChange(event) {
        // this.cron.enableFlag = true;
        const cronQuery = new Query().where('field', 'contains', event.value);
        this.cron.query = cronQuery;
        this.cron.text = null;
        if (event.value === 'time') {
          this.valueType = 3;
          this.attributeValue.text = this.$ts('Track.pleaseSelect');
          this.params.attributeValue1 = '';
          this.params.attributeValue2 = '';
          this.formObj.addRules('attributeValue3', {
            required: [true, `${this.$ts('Track.fieldIsRequired')}`],
            // regex:["^[1-9]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\\s+(20|21|22|23|[0-1]\\d):[0-5]\\d:[0-5]\\d$", "Invalid special character"],
          });
          this.formObj.removeRules('attributeValue1');
          this.formObj.removeRules('attributeValue2');
        } else {
          // this.primaryDatas.forEach((data) => {
          //
          // })
          const columns = this.primaryDatas[this.primaryDatas.findIndex(value => value.field === event.value)];
          if (columns.valueAccessor) {
            this.valueType = 2;
            this.params.attributeValue1 = '';
            this.params.attributeValue3 = '';
            this.formObj.addRules('attributeValue2', {
              required: [true, `${this.$ts('Track.fieldIsRequired')}`]
            });
            this.formObj.removeRules('attributeValue1');
            this.formObj.removeRules('attributeValue3');
            const map = new Map(columns.valueAccessor);
            const date = [];
            map.forEach(function (value, key, map) {
              date.push({ Text: value, Value: key });
            });
            this.attributeValue.data = date;
          } else {
            this.valueType = 1;
            this.attributeValue.text = this.$ts('Track.pleaseSelect');
            this.params.attributeValue2 = '';
            this.params.attributeValue3 = '';
            this.formObj.addRules('attributeValue1', {
              required: [true, `${this.$ts('Track.fieldIsRequired')}`]
            });
            this.formObj.removeRules('attributeValue2');
            this.formObj.removeRules('attributeValue3');
          }
        }

      },
      setFilter(data) {
        const columnsList = [];
        for (let i = 0; i < data.columns.length; i++) {
          if (data.columns[i].visible !== false) {
            columnsList.push(data.columns[i]);
          }
        }
        this.primaryDatas = data.columns;
        this.attributeName = {
          waterMark: this.$ts('Track.pleaseSelect'),
          enableFlag: false,
          text: '',
          fields: {
            text: 'headerText',
            value: 'field'
          },
          data: columnsList
        };
        this.cron = {
          waterMark: this.$ts('Track.pleaseSelect'),
          enableFlag: false,
          text: '',
          query: null,
          fields: {
            text: 'Text',
            value: 'Value',
            isChecked: 'Selected'
          },
          data: data.filter
        };
      },
      setDatas(data) {
        this.bindValidate();
        const errorDom = document.querySelectorAll('label.e-error');
        for (let i = 0; i < errorDom.length; i++) {
          errorDom[i].innerHTML = '';
        }
        if (data) {
          if (data.filterType === '1') {
            this.$refs.filterType[0].click();
          } else {
            this.$refs.filterType[1].click();
          }
          if (data.condition && !this.isImport) {
            this.condition.text = this.condition.data[this.condition.data.findIndex(value => value.Value === data.condition)].Text;
          } else {
            this.condition.text = '';
          }
          if (data.attributeName) {
            this.attributeName.text = this.attributeName.data[this.attributeName.data.findIndex(value => value.field === data.attributeName)].headerText;
            const columns = this.primaryDatas[this.primaryDatas.findIndex(value => value.field === data.attributeName)];
            if (columns.valueAccessor) {
              this.valueType = 2;
              const map = new Map(columns.valueAccessor);
              const date = [];
              map.forEach(function (value, key, map) {
                date.push({ Text: value, Value: key });
              });
              this.attributeValue.data = date;
            } else {
              this.valueType = 1;
            }
          } else {
            this.attributeName.text = '';
          }
          if (data.cron || data.cron === '0') {
            this.params.cron = data.cron;
            this.cron.text = this.cron.data[this.cron.data.findIndex(value => value.Value === data.cron)].Text;
          } else {
            this.cron.text = '';
          }
          if (data.attributeValue2) {
            const attributeValueData = this.attributeValue.data[this.attributeValue.data.findIndex(item => item.Value === data.attributeValue2)];
            this.attributeValue.text = attributeValueData.Text;
            this.params.attributeValue2 = attributeValueData.Value;
          } else  if (data.attributeValue3) {
            this.params.attributeValue3 = data.attributeValue3;
          } else if (data.attributeValue1) {
            this.params.attributeValue1 = data.attributeValue1;
          } else {
            this.attributeName.text = '';
          }
        }
      },
      getDatas() {
        if (this.validate()) {
          return this.params;
        }
        return false;
      },
      bindValidate() {
        this.formObj = new FormValidator(`#${this.formID}`, this.validationOption);
      },
      validate() {
        const formStatus = this.formObj.validate();
        return formStatus;
      }
    },
    mounted() {
      this.bindValidate();
    }
  };
</script>
